import React, {Component} from 'react';
import styled from 'styled-components'
import { Link, navigate } from "gatsby"
import {media} from "utils/Media"

const Wrapper = styled.div`
    .desktopUl, .mobileUl {
        margin: 0;
        padding: 0;
        position: absolute;
        left: 0;
        top: 67px;
        z-index: 501;
        background-color: ${props => props.theme.colors.white};
        display: table;
        table-layout: fixed;
        width: 100%;
        height: 44px;
        // transition: top 0.2s ease-in;
        
        &.scrollUp {
            top: 0px;
            position: fixed;
        }
    }
    
    .list {
            display: table-cell;
            margin: -5px;
            padding: 10px 15px;
            cursor: pointer;
            text-align: center;
            vertical-align: middle;
            height: inherit;
            position: relative;
            font-family: ${props => props.theme.font.family.base};
            font-size: 1rem;
            line-height: 1rem;
            height: 44px;
            
            .list--content {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);          
                width: 100%;  
            }
            
            a {
                text-decoration: none;
            }
            
            &:hover, &.active {
                background-color: ${props => props.theme.colors.lightGrey};
            }
            
            &.home {
                width: 100px;
            }
            
            &.selector {
                width: 200px;
                background-color: ${props => props.theme.colors.red};
                color: ${props => props.theme.colors.white};
            }
            
            &.coloured-list {
                display: none;
                border-bottom-style: solid;
                border-bottom-width: 5px;
                
                @media ${media.sm} {
                    display: table-cell;
                }
                
                &--yellow {
                    border-bottom-color: ${props => props.theme.colors.yellow};       
                }
                &--orange {
                    border-bottom-color: ${props => props.theme.colors.orange};       
                }
                &--purple {
                    border-bottom-color: ${props => props.theme.colors.purple};       
                }
                &--red {
                    border-bottom-color: ${props => props.theme.colors.red};       
                }
                &--blue {
                    border-bottom-color: ${props => props.theme.colors.blue};       
                }
                &--darkGrey {
                    border-bottom-color: ${props => props.theme.colors.darkGrey};       
                }
                &--green {
                    border-bottom-color: ${props => props.theme.colors.green};       
                }
            }
            
            .dropdown {
                &-menu {
                    padding: 0;
                    
                    &.show {
                        width: 100%;
                        border: none;
                        border-radius: 0;
                    }
                }
                &--wrapper {
                    position: absolute;
                    bottom: -3px;
                    left: 0;
                    width: 100%;
                    z-index: 999;
                }
                
                .list {
                    display: block;
                    width: 100%;
                    margin: 0;
                }
            }
        }
`

const scrollToElement = require('scroll-to-element');

class Menu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pagesDropdownOpen: false,
            scenesDropdownOpen: false,
            activeSceneName: "",
            activeSceneColor: "",
            activePageName: "",
            scrollUp: false,
            scrollPosition: 67,
            sceneList: [],
            pageList: []
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize, true);
        window.addEventListener('scroll', this.handleScroll, true);

        this.setState({
            sceneList: this.props.sceneList,
            pageList: this.props.pageList,
            activeSceneName: this.props.activeSceneName
        })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize, true);
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    handleScroll = () => {
        const scrollPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
        const height = 67;

        if (this.state.scrollPosition < scrollPosition && scrollPosition > height) {
            this.setState({
                scrollUp: true
            })
        } else if (this.state.scrollPosition > scrollPosition && !(scrollPosition <= height)) {
            this.setState({
                scrollUp: false
            })
        }

        this.setState({
            scrollPosition,
        })

    }

    handleResize = () => {
        const width = window.innerWidth;

        if (width < 576) {
            this.setState(prevState => ({
                scenesDropdownOpen: false,
                pagesDropdownOpen: false
            }));
        }
    }

    togglePages = () => {
        this.setState(prevState => ({
            pagesDropdownOpen: !prevState.pagesDropdownOpen,
            scenesDropdownOpen: false
        }));
    }

    toggleScenes = () => {

        this.setState(prevState => ({
            scenesDropdownOpen: !prevState.scenesDropdownOpen,
            pagesDropdownOpen: false
        }));
    }

    changeActiveMenu = (index) => {

        let sceneList = this.state.sceneList;

        this.state.sceneList.map((item, key) => {
            sceneList[key].active = key === index;
        })

        this.setState({
          sceneList,
          pagesDropdownOpen: false,
        })
    }

    onSectionClick = (hash, index, uri) => {
        
        scrollToElement(hash, {
            duration: 100,
            offset: 44
        });

        //navigate(uri, false, true)

        // TODO: Make offset change on window.resize

        this.changeActiveMenu(index)
    }

    getSceneList = (mobile = false) => {
        return (
            this.state.sceneList.map((item, index) => {
                let display = false;

                if (item.active && this.state.activeSceneName !== item.name) {
                    this.setState({
                        activeSceneName: item.name,
                        activeSceneColor: item.color
                    })
                }

                if (mobile) {
                    if (!item.active) {
                        display = true;
                    }
                } else {
                    display = true;
                }

                if (display) {
                    return (
                      <li
                        key={`${item.slug}-${index}`}
                        className={`list coloured-list coloured-list--${
                          item.color
                        } ${item.active && "active"}`}
                        onClick={() =>
                          this.onSectionClick(`#${item.slug}Scene`, index, item.uri)
                        }
                      >
                        <div className="list--content">
                          <span>{item.name}</span>
                        </div>
                      </li>
                    )
                } else {
                    return true
                }
            })
        )
    }

    getPageList = () => {
        return (
            this.state.pageList.map((item, index) => {
                if (item.active && this.state.activePageName !== item.name) {
                    this.setState({
                        activePageName: item.name
                    })
                }

                return (
                    <li key={`${item.slug}-${index}`}
                        className={`list coloured-list coloured-list--${item.color} ${item.active && 'active'}`}>
                        <div className="list--content">
                            <Link to={item.slug}>{item.name}</Link>
                        </div>
                    </li>
                )
            })
        )
    }

    render() {
        if (this.state.activeSceneName === '' && this.state.activePageName === '') {
            return true
        }
        
        return (
            <Wrapper>
                <ul className={`desktopUl d-none d-lg-table ${this.state.scrollUp && 'scrollUp'}`}>
                    <li className="list home">
                        <div className="list--content">
                            <Link to="/">Home</Link>
                        </div>
                    </li>
                    <li className="list selector" onClick={this.togglePages}
                        role="button"
                        id="dropdownPageMenu" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                        <div className="list--content">
                            {this.state.activePageName} <span className="arrow-down"/>
                        </div>
                        <div className="dropdown--wrapper">
                            <div className="dropdownForPages dropdown">
                                <ul className={`dropdown-menu ${this.state.pagesDropdownOpen && 'show'}`}
                                    aria-labelledby="dropdownPageMenu">
                                    {this.getPageList()}
                                </ul>
                            </div>

                        </div>
                    </li>

                    {this.getSceneList()}
                </ul>
                {/*
                    // Mobile menu
                */}
                <ul className={`mobileUl d-lg-none ${this.state.scrollUp && 'scrollUp'}`}>
                    <li className="list home">
                        <div className="list--content">
                            <Link to="/">Home</Link>
                        </div>
                    </li>
                    <li className="list selector" onClick={this.togglePages}
                        role="button"
                        id="dropdownPageMenu" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                        <div className="list--content">
                            {this.state.activePageName} <span className="arrow-down"/>
                        </div>
                        <div className="dropdown--wrapper">
                            <div className="dropdownForPages dropdown">
                                <ul className={`dropdown-menu ${this.state.pagesDropdownOpen && 'show'}`}
                                    aria-labelledby="dropdownPageMenu">
                                    {this.getPageList()}
                                </ul>
                            </div>

                        </div>
                    </li>
                    <li className={`list coloured-list ${this.state.activeSceneColor !== '' ? `coloured-list--${this.state.activeSceneColor}` : 'coloured-list--yellow'}`} onClick={this.toggleScenes}
                        role="button"
                        id="dropdownSceneMenu" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                        <div className="list--content">
                            {this.state.activeSceneName}
                        </div>
                        <div className="dropdown--wrapper">
                            <div className="dropdownForScenes dropdown">
                                <ul className={`dropdown-menu ${this.state.scenesDropdownOpen && 'show'}`}
                                    aria-labelledby="dropdownSceneMenu">
                                    {this.getSceneList(true)}
                                </ul>
                            </div>

                        </div>
                    </li>
                </ul>
            </Wrapper>
        );
    }
}

export default Menu